import { Validators } from '@angular/forms';
import { FieldSelectConfig } from '../../../../../shared/modules/configurable-form/components/form-multiselect/models/field-select-config.interface';
import { FormSelectComponent } from '../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { OneClickBuilderPaymentsEffects } from '../../../../effects/one-click-payment-builder.effects';
import { OneClickLoadProductPayments } from '../../../../services/commands/one-click-payments.command.service';
import { OneClickSyncJobsiteLoadProducts } from '../../../../services/commands/one-click-sync-jobsites.command.service';
import { OneClickSyncPayment } from '../../../../services/commands/one-click-sync-payment.command';
import { OneClickSyncPointOfDeliveriesLoadProducts } from '../../../../services/commands/one-click-sync-point-of-deliveries.command.service';
import { OneClickSyncProduct } from '../../../../services/commands/one-click-sync-product.command.service';
import { OneClickJobsiteLoaderService } from '../../../../services/loaders/one-click-jobsites.loader.service';
import { OneClickPaymentsLoaderService } from '../../../../services/loaders/one-click-payments.loader.service';
import { OneClickPointOfDeliveriesLoaderService } from '../../../../services/loaders/one-click-point-of-deliveries.service';
import { OneClickProductsLoaderService } from '../../../../services/loaders/one-click-products.loader.service';
import { OneClickBuilderField } from '../../../../util/constants/builder-fields';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { OneClickEditProvider } from '../../../../providers/order/one-click-edit.provider';
import { OneClickDeliveryMethodProvider } from '../../../../providers/order/one-click-delivery-method.provider';
import {
  FieldClassesDeliveryBuilder,
  FieldClassesPickUpBuilder,
} from '../../../../constants/builder-field-classes.enum';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import { OneClickQuantityBuilderProvider } from '@ordersnproducts/modules/one-click-order/providers/builder/one-click-quantity-enabler.provider';
import { OneClickSyncQuantity } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-sync-quantity.command.service';
import { DecimalProvider } from '@ordersnproducts/modules/order-builder/modules/specification/providers/decimal.provider';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { OneClickSyncUnits } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-sync-units.command.service';
import { OneCLickAlternativeUnitsBuilderEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-units-builder.effects';
import { OneClickUnitsLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-units.loader.service';
import { OneClickLoadProductUnits } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-units.command.service';
import { OneClickPreviewField } from '@ordersnproducts/modules/one-click-order/util/constants/preview-fields';
import { PricesComponent } from '@ordersnproducts/modules/one-click-order/components/prices/prices.component';
import { FormSeparatorComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-separator/form-separator.component';
import { PricesValidator } from '@ordersnproducts/modules/shared/validation/prices.validation';
import { SALES_DOCUMENT_TYPE_ID } from '@ordersnproducts/modules/shared/constants/sales-document-type-id';
import { FieldProductSelectionConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-product-selection-config.interface';
import { OneClickPriceDisablerProvider } from '@ordersnproducts/modules/one-click-order/providers/builder/one-click-price-disabler.provider';
import { OneClickProductDisabler } from '@ordersnproducts/modules/one-click-order/providers/builder/one-click-product-enabler.provider';
import { OneClickPaymentDisabler } from '@ordersnproducts/modules/one-click-order/providers/builder/one-click-payment-enabler.provider';
import { OneClickUnitDisabler } from '@ordersnproducts/modules/one-click-order/providers/builder/one-click-unit-enabler.provider';

export const jobsite: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: '',
    text: OneClickDeliveryMethodProvider.TextBuilder,
    label: 'views.one_click.delivery_method',
    containerClassNames: [FieldClassesDeliveryBuilder.DELIVERY_METHOD_READONLY],
    visible: OneClickEditProvider.VisibleEdit,
  } as FieldLabelConfig,
  {
    name: '',
    type: FormGenericItemComponent,
    text: OneClickLocationProvider.TextBuilder,
    label: 'views.one_click.jobsite',
    containerClassNames: [FieldClassesDeliveryBuilder.LOCATION_READONLY],
    visible: OneClickEditProvider.VisibleEdit,
  } as FieldLabelConfig,
  {
    name: OneClickBuilderField.Jobsite,
    type: FormSelectComponent,
    label: 'views.one_click.jobsite',
    onChange: [OneClickSyncJobsiteLoadProducts],
    placeholder: 'views.one_click.select_jobsite',
    optionsLoader: OneClickJobsiteLoaderService,
    containerClassNames: [FieldClassesDeliveryBuilder.LOCATION],
    validation: [Validators.required],
    visible: OneClickEditProvider.VisibleCreate,
  } as FieldSelectConfig,
  {
    type: FormSelectComponent,
    label: 'views.one_click.product',
    name: OneClickBuilderField.Product,
    containerClassNames: [FieldClassesDeliveryBuilder.PRODUCT],
    placeholder: 'views.one_click.select_product',
    onChange: [OneClickSyncProduct, OneClickLoadProductPayments, OneClickLoadProductUnits],
    loading: OneClickProductDisabler,
    optionsLoader: OneClickProductsLoaderService,
    validation: [Validators.required],
    dropdownSalesDocumentTypes: [SALES_DOCUMENT_TYPE_ID.TOP_PRODUCTS],
  } as FieldProductSelectionConfig,
  {
    type: FormInputNumberComponent,
    label: 'views.specifications.quantity',
    name: OneClickBuilderField.Quantity,
    containerClassNames: [FieldClassesPickUpBuilder.QUANTITY],
    value: OneClickQuantityBuilderProvider,
    min: 1,
    step: 1,
    max: 99999,
    onChange: [OneClickSyncQuantity],
    decimals: DecimalProvider,
    validation: [Validators.required, Validators.min(1), Validators.max(99999)],
    loading: OneClickPriceDisablerProvider,
  } as FieldInputNumberConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.unit',
    name: OneClickBuilderField.Unit,
    placeholder: '',
    containerClassNames: [FieldClassesPickUpBuilder.UNIT],
    onChange: [OneClickSyncUnits],
    dynamicEffects: [OneCLickAlternativeUnitsBuilderEffects],
    loading: OneClickUnitDisabler,
    optionsLoader: OneClickUnitsLoaderService,
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.paymentTerms',
    name: OneClickBuilderField.Payment,
    containerClassNames: [FieldClassesDeliveryBuilder.MULTIPRODUCT_PAYMENT_TERM],
    placeholder: 'views.one_click.select_payment',
    onChange: [OneClickSyncPayment],
    dynamicEffects: [OneClickBuilderPaymentsEffects],
    optionsLoader: OneClickPaymentsLoaderService,
    validation: [Validators.required],
    loading: OneClickPaymentDisabler,
  } as FieldSelectConfig,
  {
    type: FormSeparatorComponent,
    name: '',
    containerClassNames: ['col-md-12'],
    hidden: OneClickEditProvider.VisibleEdit,
  } as FieldConfig,
  {
    type: PricesComponent,
    name: OneClickPreviewField.Prices,
    containerClassNames: ['col-md-12'],
    validation: [PricesValidator],
  } as FieldConfig,
];

export const pod: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: '',
    text: OneClickDeliveryMethodProvider.TextBuilder,
    label: 'views.one_click.delivery_method',
    containerClassNames: [FieldClassesDeliveryBuilder.DELIVERY_METHOD_READONLY],
    visible: OneClickEditProvider.VisibleEdit,
  } as FieldLabelConfig,
  {
    name: '',
    type: FormGenericItemComponent,
    text: OneClickLocationProvider.TextBuilder,
    label: 'views.one_click.pod',
    containerClassNames: [FieldClassesDeliveryBuilder.LOCATION_READONLY],
    visible: OneClickEditProvider.VisibleEdit,
  } as FieldLabelConfig,
  {
    type: FormSelectComponent,
    name: OneClickBuilderField.PointOfDelivery,
    onChange: [OneClickSyncPointOfDeliveriesLoadProducts],
    label: 'views.one_click.pod',
    containerClassNames: [FieldClassesDeliveryBuilder.LOCATION],
    placeholder: 'views.one_click.select_pod',
    optionsLoader: OneClickPointOfDeliveriesLoaderService,
    validation: [Validators.required],
    visible: OneClickEditProvider.VisibleCreate,
  } as FieldSelectConfig,
  {
    type: FormSelectComponent,
    label: 'views.one_click.product',
    name: OneClickBuilderField.Product,
    containerClassNames: [FieldClassesDeliveryBuilder.PRODUCT],
    placeholder: 'views.one_click.select_product',
    onChange: [OneClickSyncProduct, OneClickLoadProductPayments, OneClickLoadProductUnits],
    loading: OneClickProductDisabler,
    optionsLoader: OneClickProductsLoaderService,
    validation: [Validators.required],
    dropdownSalesDocumentTypes: [SALES_DOCUMENT_TYPE_ID.TOP_PRODUCTS],
  } as FieldProductSelectionConfig,
  {
    type: FormInputNumberComponent,
    label: 'views.specifications.quantity',
    name: OneClickBuilderField.Quantity,
    containerClassNames: [FieldClassesPickUpBuilder.QUANTITY],
    value: OneClickQuantityBuilderProvider,
    min: 1,
    step: 1,
    max: 99999,
    onChange: [OneClickSyncQuantity],
    decimals: DecimalProvider,
    validation: [Validators.required, Validators.min(1), Validators.max(99999)],
  } as FieldInputNumberConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.unit',
    name: OneClickBuilderField.Unit,
    placeholder: '',
    containerClassNames: [FieldClassesPickUpBuilder.UNIT],
    onChange: [OneClickSyncUnits],
    dynamicEffects: [OneCLickAlternativeUnitsBuilderEffects],
    loading: OneClickUnitDisabler,
    optionsLoader: OneClickUnitsLoaderService,
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.paymentTerms',
    name: OneClickBuilderField.Payment,
    containerClassNames: [FieldClassesDeliveryBuilder.MULTIPRODUCT_PAYMENT_TERM],
    placeholder: 'views.one_click.select_payment',
    onChange: [OneClickSyncPayment],
    dynamicEffects: [OneClickBuilderPaymentsEffects],
    loading: OneClickPaymentDisabler,
    optionsLoader: OneClickPaymentsLoaderService,
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    type: FormSeparatorComponent,
    name: '',
    containerClassNames: ['col-md-12'],
    hidden: OneClickEditProvider.VisibleEdit,
  } as FieldConfig,
  {
    type: PricesComponent,
    name: OneClickPreviewField.Prices,
    containerClassNames: ['col-md-12'],
    validation: [PricesValidator],
  } as FieldConfig,
];
